import React from 'react';
import { LeadStatus } from '../../types/promotion';
import { CHIP_PILL } from '../../utils/chipColors';

interface LeadStatusPillProps {
  status: LeadStatus;
  className?: string;
}

// Lead lifecycle pills sourced from canonical CHIP_PILL (Family B page-level
// pills — bg-50 + ring + text-700). Each status maps to the closest semantic
// bucket: NEW→ACCENT (blue), CONTACTED→ATTENTION (amber), QUALIFIED→HIGHLIGHT
// (purple), CONVERTED→HEALTHY (emerald), DROPPED→NEUTRAL (gray).
const STATUS_CLASSES: Record<LeadStatus, string> = {
  NEW:       CHIP_PILL.ACCENT,
  CONTACTED: CHIP_PILL.ATTENTION,
  QUALIFIED: CHIP_PILL.HIGHLIGHT,
  CONVERTED: CHIP_PILL.HEALTHY,
  DROPPED:   CHIP_PILL.NEUTRAL,
};

const LeadStatusPill: React.FC<LeadStatusPillProps> = ({ status, className }) => (
  <span
    className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ring-1 ring-inset tabular-nums ${STATUS_CLASSES[status]} ${className || ''}`}
  >
    {status}
  </span>
);

export default LeadStatusPill;
